export { SpecialtyApi } from './SpecialtyApi';
